module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.3920c044.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-light-webfont.woff
// module id = 268
// module chunks = 0